import {DataSource} from "@angular/cdk/collections";
import {Doctor} from "@core/models/Doctor";
import {BehaviorSubject, merge, Observable} from "rxjs";
import {DoctorService} from "@core/http/table-data-services/Doctor.service";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {map} from "rxjs/operators";

export class DoctorDataSource extends DataSource<Doctor> {
  filterChange = new BehaviorSubject<string>('');
  filteredData: Doctor[] = [];
  renderedData: Doctor[] = [];

  constructor(
    public businessGroupId: string | null,
    public data: DoctorService,
    public paginator: MatPaginator,
    public _sort: MatSort,
    public idSucursal: string | null
  ) {
    super();
    this.filterChange.subscribe(() => (this.paginator.pageIndex = 0));
  }

  get filter(): string { return this.filterChange.value; }
  set filter(filter: string) { this.filterChange.next(filter); }

  private hasSucursal(id: string | null | undefined): id is string {
    return !!id && id.trim() !== '' &&
      id.toLowerCase() !== 'null' && id.toLowerCase() !== 'undefined';
  }

  connect(): Observable<Doctor[]> {
    const displayDataChanges = [
      this.data.dataChange,
      this._sort.sortChange,
      this.filterChange,
      this.paginator.page,
    ];

    if (this.hasSucursal(this.idSucursal)) {
      this.data.getAllDoctorsByIdBranch(this.idSucursal!); // BySucursal
    } else {
      this.data.getAllDoctors(this.businessGroupId!);      // ByGEMP
    }

    return merge(...displayDataChanges).pipe(
      map(() => {
        this.filteredData = this.data.data.slice().filter((doctor: Doctor) => {
          const searchStr = (
            doctor.idMedico + doctor.idUsuario + doctor.cedulaGeneral +
            doctor.universidad + doctor.especialidad + doctor.cedulaEspecialidad +
            doctor.horario + doctor.nombres + doctor.primerApellido + doctor.segundoApellido +
            doctor.movil + doctor.email + doctor.domicilio + doctor.idAsentamiento +
            doctor.asentamiento + doctor.tipoAsentamiento + doctor.idCP + doctor.codigoPostal +
            doctor.idMunicipio + doctor.municipio + doctor.idCiudad + doctor.ciudad +
            doctor.idEntidad + doctor.estado
          ).toLowerCase();
          return searchStr.indexOf(this.filter.toLowerCase()) !== -1;
        });

        const sortedData = this.sortData(this.filteredData.slice());
        const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
        this.renderedData = sortedData.splice(startIndex, this.paginator.pageSize);
        return this.renderedData;
      })
    );
  }

  disconnect() {}

  sortData(data: Doctor[]): Doctor[] {
    if (!this._sort.active || this._sort.direction === '') return data;
    return data.sort((a, b) => {
      let A: number | string = '', B: number | string = '';
      switch (this._sort.active) {
        case 'nombre':       [A, B] = [a.nombres, b.nombres]; break;
        case 'especialidad': [A, B] = [a.especialidad, b.especialidad]; break;
        case 'cedula':       [A, B] = [a.cedulaGeneral, b.cedulaGeneral]; break;
        case 'telefono':     [A, B] = [a.movil, b.movil]; break;
        case 'email':        [A, B] = [a.email, b.email]; break;
        case 'asentamiento': [A, B] = [a.asentamiento, b.asentamiento]; break;
        case 'cp':           [A, B] = [a.codigoPostal, b.codigoPostal]; break;
      }
      const vA = isNaN(+A) ? A : +A;
      const vB = isNaN(+B) ? B : +B;
      return (vA < vB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }
}
